import { hasItems } from "~/features/app/utils";
import { CoreVideoFeaturesGalleryDesktopView } from "./desktop";
import { CoreVideoFeaturesGalleryMobileView } from "./mobile";
import type { CoreVideoFeaturesGalleryLayoutProps, CoreVideoFeaturesGalleryViewItem } from "./shared";
export type CoreVideoFeaturesGalleryBlockViewProps = Omit<CoreVideoFeaturesGalleryLayoutProps, "items"> & {
  items?: CoreVideoFeaturesGalleryViewItem[] | null;
};
export function CoreVideoFeaturesGalleryBlockView({
  anchor,
  hasTopDivider,
  isHighlighted = false,
  items = [],
  headline,
  sectionProps
}: CoreVideoFeaturesGalleryBlockViewProps) {
  const galleryItems = items ?? [];
  if (!hasItems(galleryItems)) {
    return null;
  }
  return <>
      <CoreVideoFeaturesGalleryDesktopView anchor={anchor} items={galleryItems} hasTopDivider={hasTopDivider as boolean} isHighlighted={isHighlighted} headline={headline} sectionProps={sectionProps} />
      <CoreVideoFeaturesGalleryMobileView anchor={anchor} items={galleryItems} hasTopDivider={hasTopDivider as boolean} isHighlighted={isHighlighted} headline={headline} sectionProps={sectionProps} />
    </>;
}